export const REFERRAL_INTENT_SESSION_STORAGE_KEY =
  'CONTRA_SESSION_REFERRAL_INTENT';
export const REFERRAL_ACTION_PORTFOLIOS_WAITLIST = 'portfolios-waitlist';
export const REFERRAL_ACTION_CREATOR_EARLY_ACCESS = 'creator-contra-pro';
export const REFERRAL_ACTION_USER_REFERRAL = 'user-referral';
export const REFERRAL_C4C_DEMO = 'c4c-referral-demo';
export const REFERRAL_C4C_SIGN_UP = 'c4c-referral-sign-up';
export const CONTRA_PRO_SALES_PAGE_PARAMETER = 'contraProReferral';
export const CONTRA_PRO_WAITLIST_PARAMETER = 'contraProWaitlist';
export const CONTRA_SOCIAL_REFERRAL_PROGRAM = 'contra-social-referral-program';
